export default __webpack_public_path__ + "static/media/profile1.53c1be46.jpg";